module.exports = __webpack_public_path__ + "img/cr.7b4ebd50.svg";